import { Div } from '@expo/html-elements'
import { Text } from '../../../../../components/TextComponents'

import { dsv } from '../../../../../styles/defaults'
import type { StateHistoryEntry } from '../../../../../hooks/context/useAkteContext'
import { useTranslation } from 'react-i18next'
import { formatDateTime } from './utils'

type Action = "preRequest" | "preRequestRejected" | "request" | "approved" | "rejected" | "cancelled" | "returnFrom"
type HandoverEventData = Partial<Record<string, Partial<Record<Action, undefined | null | StateHistoryEntry>>>>

export interface UebergabeRowProps {
  handovers: string[]
  step: Action
  data: HandoverEventData
}
export function UebergabeRow({ handovers, step, data }: UebergabeRowProps) {
  const {t} = useTranslation()
  return (
    <Div
      style={{
        display: 'flex',
        flexDirection: 'row',
        marginLeft: 5,
        borderColor: dsv.colors.connectGrau30,
        borderStyle: 'solid',
        borderBottomWidth: 1,
        marginVertical: 5,
      }}
    >
      <Div style={{ width: '15%' }}>
        <Text style={{ color: dsv.colors.black }}>{t(`uebergabeAction_${step}`)}</Text>
      </Div>
      {handovers.map((handover) => {
        const event = data[handover]?.[step]
        return (
          <Div key={handover} style={{ width: `${85/handovers.length}%` }}>
            <Text>
              {
                event === undefined
                  ? "-/-"
                  : event === null
                    ? "N.a."
                    : `${formatDateTime(event.at)}`
              }
            </Text>
          </Div>
        )
      })}
    </Div>
  )
}
